import { useRef } from 'react';
import { motion as Motion } from 'framer-motion';

/**
 * MagneticButton
 * Renders as <a> when href is provided, <button> otherwise.
 * variant: 'primary' | 'secondary'
 */
export default function MagneticButton({
  children,
  href,
  type = 'button',
  variant = 'primary',
  className = '',
  disabled = false,
  onClick,
  ...rest
}) {
  const ref = useRef(null);

  const handleMouseMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width  / 2;
    const y = e.clientY - rect.top  - rect.height / 2;
    el.style.transform = `translate(${x * 0.28}px, ${y * 0.28}px)`;
  };

  const handleMouseLeave = () => {
    if (ref.current) ref.current.style.transform = 'translate(0,0)';
  };

  const baseClass = `magnetic-btn magnetic-btn--${variant} ${className}`;

  const motionProps = {
    ref,
    className: baseClass,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    whileTap: { scale: 0.96 },
    transition: { type: 'spring', stiffness: 300, damping: 20 },
    style: { transition: 'transform 0.35s cubic-bezier(0.22,1,0.36,1)' },
  };

  if (href) {
    return (
      <Motion.a href={href} {...motionProps} {...rest}>
        {children}
      </Motion.a>
    );
  }

  return (
    <Motion.button
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...motionProps}
      {...rest}
    >
      {children}
    </Motion.button>
  );
}
